import { getCurrentInstance } from "vue";

export function useStore() {
  const vm = getCurrentInstance();

  if (!vm) {
    throw new Error('"useStore" must be called in setup');
  }

  return vm.proxy.$store;
}
